'use client';

import dynamic from 'next/dynamic';

export const DynamicMobileHeader = dynamic(
  () => import('./MobileHeader').then(mod => mod.MobileHeader),
  { ssr: false }
);
